import { Box, Flex, FlexProps, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface IFeaturedDividedVertically extends FlexProps {
  title: string;
  description: string;
}

export const FeatureDividedVertically: FC<IFeaturedDividedVertically> = ({ title, description, ...rest }) => {
  return (
    <Flex textAlign="center" flexDirection="column" alignItems="center" flex={1} {...rest}>
      <Text fontFamily="heading" fontSize="lg" fontWeight="bold">
        {title}
      </Text>
      <Box w="full" borderBottom="1px solid #CACCCC" my={3} />
      <Text>{description}</Text>
    </Flex>
  );
};
